import React from 'react';

import Layout from '../components/Layout';
import PageTitle from '../components/PageTitle';
import Events from '../views/Events';
import SimpleHelmet from '../components/SimpleHelmet';
import BackgroundImage from '../components/BackgroundImage';

export const EventsTemplate = ({
  events,
  title,
  seoDescription,
  seoUrl,
  image
}) => {
  let today = new Date();
  today.setHours(0, 0, 0, 0);
  const eventsFiltered = events.filter(x => {
    return Date.parse(x.date) >= today;
  });
  return (
    <Layout>
      <BackgroundImage image={image}>
        <SimpleHelmet
          seoTitle={title}
          seoDescription={seoDescription}
          seoUrl={seoUrl}
        />
        <PageTitle title={title} transparent={true} />
        <Events events={eventsFiltered} hideTitle hideMoreLink transparent />
      </BackgroundImage>
    </Layout>
  );
};

const EventsPage = ({ data }) => {
  const events = data.events.edges.map(({ node }) => {
    const { title, day, month, year, url, location, date } = node.frontmatter;
    const description = node.html;
    return {
      title,
      day,
      month,
      year,
      date,
      url,
      location,
      description
    };
  });

  const { title, seoDescription, image } = data.metadata.frontmatter;
  const seoUrl = data.metadata.fields.slug;

  return (
    <EventsTemplate
      events={events}
      title={title}
      image={image}
      seoDescription={seoDescription}
      seoUrl={seoUrl}
    />
  );
};

export default EventsPage;

export const pageQuery = graphql`
  query EventsTemplate {
    metadata: markdownRemark(
      frontmatter: { templateKey: { eq: "events-page" } }
    ) {
      frontmatter {
        title
        seoDescription
        image {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      fields {
        slug
      }
    }
    events: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/events/.*\\\\.md$/" } }
      sort: { fields: frontmatter___date, order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            day: date(formatString: "DD")
            month: date(formatString: "MMM")
            year: date(formatString: "YY")
            date
            title
            url
            location
          }
          id
          html
        }
      }
    }
  }
`;
